import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    } else {
      document.title = 'My App'; // Fallback title
    }
  }, [title]);
};

export default useDocumentTitle;
